module.exports = {"description":"","displayName":"ProgressIndicator","methods":[],"props":{"showPercentage":{"type":{"name":"bool"},"required":false,"description":"Show percentage","defaultValue":{"value":"true","computed":false}},"currentPercentage":{"type":{"name":"number"},"required":false,"description":"Current percentage value"},"cssMap":{"defaultValue":{"value":"require( './progressIndicator.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/ProgressIndicator-props.json
// module id = 458
// module chunks = 0